import { useCallback, useEffect, useState } from 'react';

export const useTablePagination = (listTotal?: number) => {
  const [pageSize, setPageSize] = useState<number>(10);
  const [pageIndex, setPageIndex] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [gotoPageIndex, setGotoPageIndex] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [lastPageViewed, setLastPageViewed] = useState<number>(0);

  const changeTablePage = useCallback(
    ({ pageSize: vPageSize, pageIndex: vPageIndex }: { pageSize: number; pageIndex: number }) => {
      setPageSize(vPageSize);
      setPageIndex(++vPageIndex);
      setIsLoading(true);
      setGotoPageIndex(1);
    },
    []
  );

  useEffect(() => {
    if (listTotal && pageSize) {
      setTotalPages(Math.ceil(listTotal / pageSize));
    }
  }, [listTotal, pageSize]);

  const resetPagination = useCallback(() => {
    setPageIndex(1);
    setGotoPageIndex(0);
    setLastPageViewed(0);
  }, []);

  return {
    pageSize,
    pageIndex,
    totalPages,
    isLoading,
    setIsLoading,
    gotoPageIndex,
    setGotoPageIndex,
    changeTablePage,
    resetPagination,
    lastPageViewed,
    setLastPageViewed,
  };
};
